import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Gallery() {
  const { lang, t } = useLang();
  const [items, setItems] = React.useState([]);
  const [active, setActive] = React.useState(null);

  React.useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="gallery-page">
      <SEO title="Galeri Perjalanan Suci" titleEn="Sacred Journey Gallery" description="Galeri foto perjalanan umrah & haji jamaah BATIK Tour & Travel dari Masjidil Haram, Masjid Nabawi, hingga manasik bersama." />
      <section className="pt-32 lg:pt-40 pb-12">
        <div className="container-x max-w-3xl">
          <p className="overline mb-5">{t("sections.galleryOver")}</p>
          <h1 className="h-display text-primary">{t("gallery.title")}</h1>
          <p className="mt-6 text-lg text-muted-foreground">{t("gallery.sub")}</p>
        </div>
      </section>

      <section className="pb-32">
        <div className="container-x">
          <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
            {items.map((g) => (
              <button
                type="button"
                key={g.id}
                onClick={() => setActive(g)}
                data-testid={`gallery-item-${g.id}`}
                className={`relative overflow-hidden rounded-lg group ${g.span}`}
              >
                <img
                  src={g.image}
                  alt={lang === "id" ? g.title_id : g.title_en}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/70 via-primary/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <span className="text-white font-serif text-lg text-left">{lang === "id" ? g.title_id : g.title_en}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[100] bg-primary/90 flex items-center justify-center p-6"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <img
            src={active.image}
            alt={lang === "id" ? active.title_id : active.title_en}
            className="max-w-full max-h-[88vh] object-contain rounded-lg"
          />
          <p className="absolute bottom-6 text-white font-serif text-xl">{lang === "id" ? active.title_id : active.title_en}</p>
        </div>
      )}
    </div>
  );
}
